import React from 'react';
import PropTypes from 'prop-types';
import Profile from './Profile';
import Modal from './Modal';
import './ProfileSelectorModal.css';

export default function ProfileSelectorModal(props) {
  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={props.onRequestClose}
      className="profile-selector-modal"
      showCloseButton
    >
      <Profile {...props} />
    </Modal>
  );
}

ProfileSelectorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isLoadingProfiles: PropTypes.bool.isRequired,
  isManagingProfiles: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  onSelectProfile: PropTypes.func.isRequired,
  ...Profile.PropTypes
};



// WEBPACK FOOTER //
// ./src/components/ProfileSelectorModal.js